import qs from 'qs'

/**
 *  时间戳转换  
 * @param {number} date  [转换的日期]
 * @param {string} spare [年月日数间隔符]
 * @param {string} timeSpare [时分秒间隔符]
 */
const filterTime = (date: number = Date.now(), spare: string = '-', timeSpare: string = ':',hasTime=true) => {
  // 补零
  function fix(i: any) {
    typeof i !== 'number' ? i = parseInt(i) : null
    return i < 10 ? `0${i}` : i
  }
  // 生成时间
  function time(t: any, spare = '-', timeSpare = ':',hasTime=true) {
    let [y, m, d, h, mi, ms] = [
      new Date(t).getFullYear(),
      new Date(t).getMonth() + 1,
      new Date(t).getDate(),
      new Date(t).getHours(),
      new Date(t).getMinutes(),
      new Date(t).getSeconds()
    ]
    if(hasTime){
      return `${y}${spare}${fix(m)}${spare}${fix(d)} ${fix(h)}${timeSpare}${fix(mi)}${timeSpare}${fix(ms)}`
    }else{
      return `${y}${spare}${fix(m)}${spare}${fix(d)}`
    }
  }
  // 获取长度
  let len: any = null
  let d: any = date
  if (typeof date === 'number') {
    date = parseInt(d)
    len = date.toString().length
  } else {
    len = d.length
    len == 13 ? date = parseInt(date) : null
  }
  if (len === 10) {
    return time(date * 1000, spare, timeSpare,hasTime)
  } else if (len === 13) {
    return time(date, spare, timeSpare,hasTime)
  } else {
    return time(date, spare, timeSpare,hasTime)
  }
}

export default filterTime;